export default __webpack_public_path__ + "static/media/share-new-icon.001b2088.svg";